import { MoreVert } from "@mui/icons-material";
import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import { useTranslation } from "common/locales";
import { FileEntry, useAppSelector } from "model";
import { getFormattedDate } from "../../common/utils/getFormattedTime";

import { useState } from "react";

import ArticleIcon from "@mui/icons-material/Article";
import UpdateAndDowloadFileEntryDialog from "features/fileManagement/UpdateFileEntryDialog";

export default function RelevantFileEntryListItem({
  fileEntry,
}: {
  fileEntry: FileEntry;
}) {
  const { t } = useTranslation();
  const locale = useAppSelector((state) => state.app.locale);

  const icon = <ArticleIcon fontSize="large" />;

  const formattedTime = getFormattedDate(fileEntry.creationDate ?? "", locale);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  function openMenu(event: React.MouseEvent<HTMLButtonElement>) {
    setMenuAnchor(event.currentTarget);
  }

  function closeMenu() {
    setMenuAnchor(null);
  }

  return (
    <ListItem key={`re-listitem-${fileEntry.guid}`}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        secondary={
          <>
            <Typography
              component="span"
              display="block"
              whiteSpace="pre-line"
              noWrap={false}
              style={{ wordWrap: "break-word", overflowWrap: "break-word" }}
            >
              {fileEntry.fileName}
            </Typography>

            <Typography component="span" display="block" noWrap>
              {t(
                `fileEntries.fileUploadType.label.${fileEntry.fileUploadType}`
              )}
            </Typography>

            {fileEntry.fileDescription && (
              <Typography
                component="span"
                display="block"
                textOverflow="ellipsis"
                overflow="auto"
              >
                {t("fileEntry.fileDescription.name")}:{" "}
                {fileEntry.fileDescription}
              </Typography>
            )}
          </>
        }
      />
      <ListItemSecondaryAction>
        <IconButton
          edge="end"
          aria-haspopup="true"
          onClick={openMenu}
          id={fileEntry.guid}
          size="large"
        >
          <MoreVert />
        </IconButton>
        {
          <UpdateAndDowloadFileEntryDialog
            closeMenu={closeMenu}
            menuAnchor={menuAnchor}
            fileEntry={fileEntry}
          />
        }
      </ListItemSecondaryAction>
    </ListItem>
  );
}
